module.exports = __webpack_public_path__ + "static/media/120-thumb down.73d82b1c.svg";